import { makeObservable, observable } from 'mobx';

import { InvoiceLineItem } from '~hooks/useInvoiceLineItems/models';
import { roundToTwoDecimals } from '~pages/Approvals/DriverPay/helpers';

export default class InvoiceLineItemsStore {
  invoiceLineItemsByInvoiceId: Record<string, InvoiceLineItem[]> = {};
  invoiceSubtotalByInvoiceId: Record<string, number> = {};
  freightTotalByInvoiceId: Record<string, number> = {};
  freightQuantityByInvoiceId: Record<string, number> = {};
  lineItemsHasEditsByInvoiceId: Record<string, boolean> = {};
  // Invoice IDs currently being edited. While locked, line item writes are
  // dropped so RTU-driven refetches can't overwrite in-edit split rows.
  editLockedInvoiceIds: Set<string> = new Set();

  constructor() {
    makeObservable(this, {
      invoiceLineItemsByInvoiceId: observable,
      invoiceSubtotalByInvoiceId: observable,
      freightTotalByInvoiceId: observable,
      freightQuantityByInvoiceId: observable,
      lineItemsHasEditsByInvoiceId: observable,
      editLockedInvoiceIds: observable,
    });
  }

  setInvoiceLineItemsByInvoiceId(
    invoiceId: string,
    invoiceLineItems: InvoiceLineItem[],
    options?: { bypassEditLock?: boolean },
  ) {
    if (!options?.bypassEditLock && this.editLockedInvoiceIds.has(invoiceId)) return;
    this.invoiceLineItemsByInvoiceId[invoiceId] = [...invoiceLineItems];
  }

  setEditLockForInvoice(invoiceId: string, locked: boolean) {
    if (locked) {
      this.editLockedInvoiceIds.add(invoiceId);
    } else {
      this.editLockedInvoiceIds.delete(invoiceId);
    }
  }

  setInvoiceSubtotalByInvoiceId(invoiceId: string, subtotal: number) {
    this.invoiceSubtotalByInvoiceId[invoiceId] = roundToTwoDecimals(subtotal);
  }

  setFreightTotalByInvoiceId(invoiceId: string, freightTotal: number) {
    this.freightTotalByInvoiceId[invoiceId] = roundToTwoDecimals(freightTotal);
  }

  setFreightQuantityByInvoiceId(invoiceId: string, freightQuantity: number) {
    this.freightQuantityByInvoiceId[invoiceId] = freightQuantity;
  }

  setLineItemsHasEditsByInvoiceId(invoiceId: string, hasEdits: boolean) {
    this.lineItemsHasEditsByInvoiceId[invoiceId] = hasEdits;
  }
}
